<div class="pod-section" [formGroup]="form">

  <h2 class="pod-section__title">{{ sectionLabel }}</h2>

  <div class="pod-grid">

    <div class="pod-field" [class.pod-field--error]="isInvalid(F.COMPANY_TO_BILL)">
      <one-select
        #companySelect
        [config]="searchSelectConfig"
        [dataSource]="selectSources[F.COMPANY_TO_BILL]"
        [label]="LABELS[F.COMPANY_TO_BILL]"
        (selectionChanged)="onSelectChange(F.COMPANY_TO_BILL, $event)"
      ></one-select>
      <span class="pod-field__error" *ngIf="isInvalid(F.COMPANY_TO_BILL)">*Required</span>
    </div>

    <div class="pod-field" [class.pod-field--error]="isInvalid(F.POINT_OF_CONTACT)"
         [class.pod-select--disabled]="isPointOfContactDisabled">
      <one-select
        #pocSelect
        [config]="searchSelectConfig"
        [dataSource]="selectSources[F.POINT_OF_CONTACT]"
        [label]="pointOfContactLabel"
        [showEditIcon]="!isPointOfContactDisabled"
        (selectionChanged)="onSelectChange(F.POINT_OF_CONTACT, $event)"
        (editOption)="onEditContactOption($event)"
      ></one-select>
      <button
        *ngIf="!isPointOfContactDisabled"
        type="button"
        class="pod-field__under"
        (click)="openCreateContactDialog()"
      >{{ CREATE_CONTACT_LABEL }}</button>
      <span class="pod-field__error" *ngIf="isInvalid(F.POINT_OF_CONTACT)">*Required</span>
    </div>

    <div class="pod-field" [class.pod-field--error]="isAgencyInvalid()">
      <one-select
        #agencySelect
        [config]="searchSelectConfig"
        [dataSource]="selectSources[F.AGENCY]"
        [label]="agencyLabel"
        (selectionChanged)="onSelectChange(F.AGENCY, $event)"
      ></one-select>
      <span class="pod-field__error" *ngIf="isAgencyInvalid()">*Required</span>
    </div>

    <div class="pod-field" *ngIf="isAgencyRecognitionVisible" [class.pod-field--error]="isInvalid(F.AGENCY_RECOGNITION_METHOD)">
      <one-select
        #agencyRecognitionSelect
        [config]="selectConfig"
        [dataSource]="selectSources[F.AGENCY_RECOGNITION_METHOD]"
        [label]="LABELS[F.AGENCY_RECOGNITION_METHOD]"
        (selectionChanged)="onSelectChange(F.AGENCY_RECOGNITION_METHOD, $event)"
      ></one-select>
      <span class="pod-field__error" *ngIf="isInvalid(F.AGENCY_RECOGNITION_METHOD)">*Required</span>
    </div>

  </div>
</div>
